module.exports = __webpack_public_path__ + "img/icon7.9c184d1e.png";